import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { PedidoAnexo } from 'src/app/models/pedido-anexo';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EnumService } from 'src/app/services/enum.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoAnexoService } from 'src/app/services/pedido-anexo.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-pedido-anexo',
  templateUrl: './cadastrar-pedido-anexo.component.html',
  styleUrls: ['./cadastrar-pedido-anexo.component.scss']
})
export class CadastrarPedidoAnexoComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  idPedidoAnexo;
  idPedido;
  pedidoAnexo = new PedidoAnexo();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';
  origem = 0;
  tipo = 0;

  integrador = false;
  bloqExcluirAnexo = false;
  administrador = false;
  idUsuario = 0;
  premissasSistema = new PremissasSistema();
  idUsuarioAnexo = 0;

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private pedidoAnexoService: PedidoAnexoService, private enumService: EnumService,
    private router: Router, private viaCepService: ViaCepService, public dialog: MatDialog,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService, public dialogRef: MatDialogRef<CadastrarPedidoAnexoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private arquivoService: ArquivoService, private premissasService: PremissasService) {
    this.idPedidoAnexo = data.id;
    this.idPedido = data.idPedido;
    this.origem = data.origem;
    this.tipo = data.tipo;
    this.idUsuarioAnexo = data.idUsuarioAnexo;
  }

  async ngOnInit() {

    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();
    this.idUsuario = (await this.globalService.consultaUsuario()).id;
    this.buscarPremissasSistema();

    // se for edição, busca o pedidoAnexo do id passado
    if (this.idPedidoAnexo) {
      this.editando = true;
      this.buscarPedidoAnexo();
    } else {
      this.pedidoAnexo = new PedidoAnexo();
      this.pedidoAnexo.arquivo = '';
      this.pedidoAnexo.comprovantePagamento = false;
      this.atualizaDadosPedidoAnexo();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPedidoAnexo() {

    this.carregandoService.mostra('buscaPedidoAnexo');

    this.pedidoAnexoService.consultarPorIdPedidoAnexo(this.idPedidoAnexo).subscribe(tipo => {
      this.pedidoAnexo = tipo;
      this.nomeArquivoBanco = this.pedidoAnexo.arquivo;
      this.atualizaDadosPedidoAnexo();
    }, (erro) => {
      this.carregandoService.esconde('buscaPedidoAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosPedidoAnexo() {

    this.carregando = false;

    this.carregandoService.esconde('buscaPedidoAnexo');
  }

  salvar() {
    this.carregandoService.mostra('salvaPedidoAnexo');

    this.pedidoAnexo.idCupom = this.idPedido;
    this.pedidoAnexo.origem = this.origem;

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.pedidoAnexo.arquivo);
    }

    dados.append('arqui[id]', this.pedidoAnexo.id ? this.pedidoAnexo.id.toString() : '0');
    dados.append('arqui[descricao]', this.pedidoAnexo.descricao);
    dados.append('arqui[idCupom]', this.idPedido);
    dados.append('arqui[origem]', this.origem.toString());
    dados.append('arqui[idAnexo]', this.pedidoAnexo.idAnexo ? this.pedidoAnexo.idAnexo.toString() : '0');
    dados.append('arqui[comprovantePagamento]', this.pedidoAnexo.comprovantePagamento.toString());

    if (this.pedidoAnexo.valorComprovante) {
      const valorComprovante = Number(this.pedidoAnexo.valorComprovante);
      if (!isNaN(valorComprovante)) {
        dados.append('arqui[valorComprovante]', valorComprovante.toFixed(2).replace('.', ','));
      }
    }


    this.pedidoAnexoService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Anexo salvo com sucesso!!!');
      this.carregandoService.esconde('salvaPedidoAnexo');
      this.dialogRef.close(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaPedidoAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idPedidoAnexo, TipoArquivo.PedidoAnexo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.pedidoAnexo.arquivo = '';
  }

}
